import { VerticalSpacer } from '@superhi/design'
import styled from 'styled-components'

type WrapperProps = {
  $noPadding: boolean
  $hAlign: 'center' | 'left'
}

export const Wrapper = styled(VerticalSpacer).attrs({
  amount: { small: 8, medium: 8, large: 8 },
})<WrapperProps>`
  padding: ${({ $noPadding }) => (!$noPadding ? 96 : 0)}px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ $hAlign }) => ($hAlign === 'center' ? 'center' : 'flex-start')};
`
